import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Sort } from '@angular/material/sort';
import { Router } from '@angular/router';
import moment from 'moment';
import { BaseComponent } from 'src/app/core/base.component';
import { OutingService } from 'src/app/outing/outing.service';
import { AlertModalComponent } from 'src/app/shared/modals/alert-modal/alert-modal.component';
import { QueryFilter } from 'src/app/shared/models/query-filter.model';
import { GlobalDataService } from 'src/app/shared/services/global-data.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { OutingIterationQueryFilter } from '../models/outing-iteration-query-filter';
import { OutingIterationList } from '../models/outing-iteration.list';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';


@Component({
    selector: 'app-outing-iteration-list',
    templateUrl: './outing-iteration-list.component.html',
    styleUrls: ['./outing-iteration-list.component.scss'],
    standalone: false
})
export class OutingIterationListComponent extends BaseComponent implements OnInit {
  @Input() filter: QueryFilter = new QueryFilter();
  @Input() iterationFilter: OutingIterationQueryFilter = new OutingIterationQueryFilter();
  public updateFilterEvent = new EventEmitter<any>();
  public updateIterationFilterEvent = new EventEmitter<any>();
  public outingIterations: OutingIterationList[] = [];
  public isOutingIterationsLoading: boolean = false;

  constructor(public sessesService: SessionService,
    private outingService: OutingService,
    private router: Router,
    private dialog: MatDialog,
    private globalDataService: GlobalDataService,
    stringHelpers: StringHelpers) {
    super(sessesService, stringHelpers)
      this.displayedColumns = ['courseName', 'startDate', 'cost', 'registrationCode', 'actions']
   }

  ngOnInit(): void {
    if(this.isGlobalOutingSet()){
      this.selectedOuting = this.getGlobalOuting();
      this.getOutingIterations();
    }
  }

  getOutingIterations(): any{
    this.isOutingIterationsLoading = true;
    this.iterationFilter.isSubset = false;
    this.iterationFilter.outingId = this.selectedOuting.id;
    this.outingService.getOutingIterationsByOutingId(this.selectedOuting.id, this.iterationFilter).subscribe(results =>{
      if(results.totalCount > 0){
        this.outingIterations = results.results;
        this.iterationFilter.totalCount = results.totalCount;
        this.updateIterationFilterEvent.emit(results.results);
      }else{
        this.outingIterations = [];
      }
      this.isOutingIterationsLoading = false;      
    });
  }

  addIteration(){
    this.setSearchKey(this.getGlobalOuting());
    this.router.navigate(['../outing-management/administration/outing', 'iteration', 'create', this.searchKey]);
  }

  deleteIteration(iteration: OutingIterationList){
    const dialogRef = this.dialog.open(AlertModalComponent);
    dialogRef.componentInstance.title = 'Iteration Delete';
    dialogRef.componentInstance.body = `Are you sure you want to delete course iteration <strong>"${iteration.courseName}"</strong> on <strong>"${moment(iteration.startDate).format("MM-DD-YYYY hh:mm a")}"</strong>?`;
    dialogRef.componentInstance.submitText = 'Yes';
    dialogRef.componentInstance.otherText = 'No';
    dialogRef.componentInstance.isOtherTextDisabled = false;
    dialogRef.afterClosed().subscribe((response) => {
      if(response === 'Yes'){
        this.isOutingIterationsLoading = true;
        let data = {id: iteration.id, lastEditedBy: this.getUserIdFromSession()};
        this.outingService.deleteOutingIteration(data).subscribe(() => {
          this.getOutingIterations();
          this.isOutingIterationsLoading = false;
        }, err =>{
          this.isOutingIterationsLoading = false;
          //throw error
        });
      }
    });
  }

  iterationDetails(iteration: OutingIterationList){
    this.setSearchKey(iteration);
    this.router.navigate(['../outing-management/administration/outing', 'iteration', 'details', this.searchKey]);
  }

  sortOutingData(sort: Sort) {
    this.filter.sortDirection = sort.direction;
    this.filter.sortColumn = sort.active;
  }

  resetOutingFilter() {
    this.filter.page = 1;
    this.filter.text = '';
    this.filter.pageSize = 10;
  }

  sortIterationData(sort: Sort) {
    this.iterationFilter.sortDirection = sort.direction;
    this.iterationFilter.sortColumn = sort.active;
  }

  resetIterationFilter() {
    this.iterationFilter.page = 1;
    this.iterationFilter.text = '';
    this.iterationFilter.pageSize = 10;
  }
}
